import React from 'react';
import { useHistory } from 'react-router-dom';
import { PageContainerSmall } from '../../../styles/styles';
import { LinkCardCustom } from '../../../components/Cards/LinkCard';

import { useGlobal } from '../../../contexts/Global/context';

import * as S from './styles';

function EscolherTipoContrato() {
    const LINK_TO_ACTIVES = '/dados_contrato/planos_valores/planos_valores_ativos';

    const { dataActiveContract } = useGlobal();

    const history = useHistory();

    if (!dataActiveContract.exigeTermoContributario) {
        history.push(LINK_TO_ACTIVES);
    }

    return (
        <PageContainerSmall>
            <LinkCardCustom
                link={LINK_TO_ACTIVES}
                title="Para beneficiários ativos"
                desc="Confira dados e valores dos planos."
                icons={{ left: { name: 'description' } }}
            />

            <S.SpacingCards />

            <LinkCardCustom
                link="/dados_contrato/planos_valores/planos_valores_aposentados_demitidos"
                title="Para aposentados e demitidos"
                desc="Confira dados e valores dos planos."
                icons={{ left: { name: 'description' } }}
                altImg="Adicionar Dependente"
            />
        </PageContainerSmall>
    );
}

export default EscolherTipoContrato;
